import type { LiveProvider } from '@refinedev/core';
import { getLiveClient } from './socket';

/**
 * `liveProvider` de Refine sobre el mismo canal que usa el panel.
 *
 * Su trabajo es que los hooks de Refine (`useList`, `useOne`) se refresquen
 * solos cuando un nodo cambia. Las pantallas de la Fase 1 leen el estado del
 * árbol vivo, pero dejar esto puesto hace que cualquier CRUD que se añada
 * después herede el comportamiento sin tocar nada.
 */

const NODES_CHANNEL = 'resources/nodes';

export const liveProvider: LiveProvider = {
  subscribe({ channel, callback }) {
    if (channel !== NODES_CHANNEL) return null;

    return getLiveClient().subscribe((event) => {
      callback({
        channel: NODES_CHANNEL,
        type: 'updated',
        payload: { ids: [event.nodeId] },
        date: new Date(),
      });
    });
  },

  unsubscribe(subscription: unknown) {
    if (typeof subscription === 'function') (subscription as () => void)();
  },
};
